import { GetterTree } from "vuex";
import * as types from '@/store/types'

export default <GetterTree<RootState, RootState>>{
  [types.CURRENT_MAIL_ITEM](state) {
    return state.currentItem;
  },

  [types.PANE_LOADING](state) {
    return state.paneLoading;
  },

  [types.VALID_DOMAIN](state) {
    return state.validDomain;
  },

  [types.ORIGINAL_RECIPIENTS_GET](state) {
    return state.originalRecipients;
  },

  [types.INDEXED_RECIPIENTS_GET](state) {
    return state.indexedRecipients;
  },

  [types.RECIPIENTS_WITH_STATUS_GET](state) {
    return state.recipientsWithStatus;
  },

  [types.SEARCH_TARGET_GET](state) {
    return state.searchTargetList;
  },
};